import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./UserAccountTransfers.scss";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { addEmerlinkContact, emerlinkLoad, emerlinkReceiveMoney, emerlinkSendMoney, emerlinkTrackTransfer, getEmerlinkReceiveTransaction, getEmerlinkSendTransactionDetails, getEmerlinkStatesAndCurrency, registerEmerlinkUser } from "../../../util/API/emerlink";
import { useSelector } from "react-redux";
import { countryList } from "../../../constants/countrylist";
import RegistrationSelect from "../../UI/Registration/RegistrationSelect";
import RegistrationInput from "../../UI/Registration/RegistrationInput";
import { decodeHtmlEntities, getErrorMessage } from "../../../util/utilfunctions/utilFunctions";
import PinPad from "../../PinPad/PinPad";
import Contacts from "./Contacts";
import InternationalTransferFooterButtons from "./InternationalTransfers/InternationalTransferFooterButtons";
import InternationalTransferHistory from "./InternationalTransfers/InternationalTransferHistory";
import InternationalTransferTrack from "./InternationalTransfers/InternationalTransferTrack";
import CustomAlert from "../../UI/CustomAlert/CustomAlert";
import { serviceUrl } from "../../../config";

function Emerlink({handleBack}) {

    // const BACKEND_URL = serviceUrl;
    let configVariables = useSelector((state) => state.config.baseConfig);
    let isDevEnv = configVariables.devEnvironment;

    Emerlink.propTypes = {
        handleBack: PropTypes.func
    }

    const [page, setPage] = useState("wait");
    const [contacts, setContacts] = useState(null);
    const [history, setHistory] = useState(null);
    const [purposesOptions, setPurposesOptions] = useState([]);
    const [fundPurposesOptions, setFundPurposesOptions] = useState([]);
    const [relationshipOptions, setRelationshipOptions] = useState([]);
    const [formValues, setFormValues] = useState({});
    const [formErrors, setFormErrors] = useState({});
    const [receivingStates, setReceivingStates] = useState([]);
    const [receiverStates, setReceiverStates] = useState([]);
    const [receivingCurrencies, setReceivingCurrencies] = useState([]);
    const selectedUser = useSelector((state) => state.usersList.selectedUser);
    const [selectedContact, setSelectedContact] = useState(null);
    const [contactButtonText, setContactButtonText] = useState("Save contact");
    const [showPin, setShowPin] = useState(false);
    const selectedUserID = selectedUser.User.id;
    const [transactionStatus, setTransactionStatus] = useState(null);
    const [alert, setAlert] = useState({});
    const [disableContactButton, setDisableContactButton] = useState(false);
    let agent = sessionStorage.getItem("user");
    agent = JSON.parse(agent);
    agent = agent.payload.body.User;

    let isOperator = sessionStorage.getItem("isOperator");
    let parentuserid = sessionStorage.getItem("parentuserid");


    useEffect(() => {
        async function getProfile() {
            let response = await registerEmerlinkUser(selectedUserID);
            let status = response.Status;
            if (status === '2') {
                setAlertData(response, true, false);
                return;
            }
            editFormValues('userid', selectedUserID);
            getLandingScreenData();
        }
        getProfile();
    }, []);

    useEffect(() => {
        if (page === 'landing') {
            setSelectedContact(null);
            // setFormValues({});
            getLandingScreenData();
        } else if (page === 'getTransaction') {
            getSummaryDetails();
        } else if (page === 'sendTransaction') {
            setShowPin(true);
        } else if (page === 'send') {
            setFormValues((prev) => ({
                ...prev,
                transferType: 'send'
            }));
        } else if (page === 'receive') {
            setFormValues((prev) => ({
                ...prev,
                transferType: 'receive'
            }));
        }
    }, [page]);


    const getSummaryDetails = async () => {
        setPage('wait');
        // console.log("getSummaryDetails==============",formValues);
        let response;
        if (formValues.referencenumber) {
            response = await getEmerlinkReceiveTransaction(formValues);
        } else {
            response = await getEmerlinkSendTransactionDetails(formValues);
        }
        let callStatus = response.Status;
        if (callStatus !== "1") {
            setAlertData(response, true, true);
            return;
        }

        const emerlinkResponse = response.payload.body;
        const transactionInfo = emerlinkResponse?.trnInfo ?? emerlinkResponse.trnRcvInfo;
        const sessionID = emerlinkResponse.sessionID;
        const fee = transactionInfo?.sendFee ?? transactionInfo.receiveFees;
        const taxes = transactionInfo?.sendTaxes ?? 0;
        const adminFee = transactionInfo?.sendOtherFee ?? 0;
        const totalToCollect = transactionInfo?.totalAmountToCollect ?? transactionInfo.totalAmountToReceive;
        const receiveAmount = transactionInfo?.receiveAmount ?? 0;
        const senderFirstName = transactionInfo?.senderFirstName ?? '';
        const senderLastName = transactionInfo?.senderLastName ?? '';
        const originatingCountry = transactionInfo?.originatingCountry ?? '';
        let dateTimeSent = transactionInfo?.dateTimeSent ?? '';
        dateTimeSent = dateTimeSent.split('T')[0];
        setFormValues((prev) => ({
            ...prev,
            'externalrefid': sessionID,
            'servicefee': parseFloat(fee),
            'adminfee': parseFloat(adminFee),
            'taxamount': taxes,
            'totalamount': totalToCollect,
            'receiveamount': receiveAmount,
            'senderFirstName': senderFirstName,
            'senderLastName': senderLastName,
            'originatingCountry': originatingCountry,
            'dateTimeSent': dateTimeSent,
        }));
        checkContactExists();
        if (formValues.referencenumber) {
            setPage('summaryreceive');
        } else {
            setPage('summary');
        }
    }

    const getLandingScreenData = async () => {
        if (page === 'landing') return;
        let response = await emerlinkLoad(selectedUserID);
        if (response.Status !== "1") {
            return;
        }
        let contactArray = response.contacts.body.record;
        if (!Array.isArray(contactArray)) {
            contactArray = [contactArray];
        }
        // console.log("contactArray1=========", contactArray);
        contactArray = contactArray.filter((contact) => {
            try {
                const otherdata = contact.Usercontactlistexternal.other.replaceAll(/&(amp;)*quot;/g, '"');
                const parsedData = JSON.parse(otherdata);
                // console.log("parsedData=========", parsedData);
                return parsedData.rel && parsedData.ctry;
            } catch (error) {
                return false;
            }
        });
        setContacts(contactArray);
        let historyArray = response.history.body.record;
        if (!Array.isArray(historyArray)) {
            historyArray = [historyArray];
        }
        historyArray = historyArray.filter((historyItem) => {
            try {
                const data = historyItem.Useritem.itemdata.replaceAll(/&(amp;)*quot;/g, '"');
                const parsedData = JSON.parse(data);
                console.log("parsedData===",parsedData);
                // if (parsedData?.transtype !== 66) {
                //     return false;
                // }
                return parsedData?.emerlinkrefnumber;
            } catch (error) {
                return false;
            }
        });
        setHistory(historyArray);
        let fundPurposes = getRunQueryData(response.fundpurpose);
        setFundPurposesOptions(fundPurposes);
        let relationships = getRunQueryData(response.relationships);
        setRelationshipOptions(relationships);
        let purposes = getRunQueryData(response.purposes);
        setPurposesOptions(purposes);
        setFormValues({
            'agentid': agent.id,
            'agentName': agent.firstName + " " + agent.lastName,
            'agentCountry': agent.countryid,
            'userid': selectedUserID,
            'isOperator': isOperator,
            'parentuserid': parentuserid
        });
        setPage("landing");
    }

    async function sendMoney(userpin) {
        setPage("wait");
        let response = await emerlinkSendMoney(formValues, userpin);
        let callStatus = response.payload.callStatus;
        if (callStatus !== '1') {
            setAlertData(response, true, true);
            return;
        }
        let customerData = response.payload.forCustomer;
        let emerlinkrefnumber = customerData.emerlinkrefnumber;
        let refid = customerData.refid;
        setFormValues((prev) => ({
            ...prev,
            'emerlinkrefnumber': emerlinkrefnumber,
            'refid': refid,
        }));
        setPage('receipt');
    }
    async function receiveMoney(userpin) {
        setPage("wait");
        let request = formValues;
        request['isOperator'] = isOperator;
        request['parentuserid'] = parentuserid;
        let response = await emerlinkReceiveMoney(request, userpin);
        let callStatus = response.payload.callStatus;
        if (callStatus !== '1') {
            setAlertData(response, true, true);
            return;
        }
        let customerData = response.payload.forCustomer;
        let emerlinkrefnumber = customerData.emerlinkrefnumber;
        let refid = customerData.refid;
        setFormValues((prev) => ({
            ...prev,
            'emerlinkrefnumber': emerlinkrefnumber,
            'refid': refid,
        }));
        setPage('receipt');
    }

    useEffect(() => {
        if (selectedContact) {
            setPage('contact');
        }
    }, [selectedContact])

    const trackTransaction = async (refNumber, data) => {
        let itemData = JSON.parse(data.replaceAll(/&(amp;)*quot;/g, '"'));
        let referenceNumber = itemData.emerlinkrefnumber;
        let sessionid = itemData.sessionID;
        let response = await emerlinkTrackTransfer(sessionid, referenceNumber);
        if (response.Status !== '1') {
            setAlertData(response, true, true);
            return;
        }
        const status = response.payload.body.transactionStatus;
        setTransactionStatus(status);
        setPage("track");
    }

    const resendTransaction = (data) => {
        let itemData = JSON.parse(data.replaceAll(/&(amp;)*quot;/g, '"'));
        let receiverName = itemData.recipientname.split(" ");
        console.log("resendTransaction_itemData============",itemData);
        setFormValues((prev) => ({
            ...prev,
            receiverfirstname: receiverName[0],
            receiverlastname: receiverName[1],
            receivecountry: itemData.receivingcountry,
            receivingstate: itemData.receivingstate,
            currencytoreceive: itemData.receivingcurrency,
            receivercountry: itemData.receivercountry,
            receiverstate: itemData.receiverstate,
            relationshipreceiver: itemData.relationship,
            transferType: "send"
        }));
        setPage("shortform");
    }

    const sendToContact = () => {
        let contactOther = JSON.parse(selectedContact.Usercontactlistexternal.other.replaceAll(/&(amp;)*quot;/g, '"'));
        console.log("selectedContact============",selectedContact);
        console.log("contactOther============",contactOther);
        setFormValues((prev) => ({
            ...prev,
            receiverfirstname: selectedContact.Usercontactlistexternal.firstName,
            receiverlastname: selectedContact.Usercontactlistexternal.lastName,
            receivecountry: contactOther.ctry,
            currencytoreceive: contactOther.cur,
            receivercountry: contactOther.rctry,
            receiverstate: contactOther.state,
            receivingstate: contactOther.state,
            receivercity: contactOther.city,
            receivermiddlename: contactOther.mname,
            receiveraddress: contactOther.addr,
            receiverphone: contactOther.ph,
            relationshipreceiver: contactOther.rel,
            transferType: "send"
        }));
        setPage("shortform");
    }

    const getRunQueryData = (response) => {
        let record = response.body.record;
        let values = [];
        for (let purpose of record) {
            let attribute = purpose.domainattributes.domainatt;
            let name = purpose.domainattributes.attname;
            values.push({ 'value': attribute, 'key': attribute, 'label': name });
        }
        return values;
    }

    const editFormValues = (key, value) => {
        if (key === 'receivecountry' || key === 'receivercountry') {
            getStateData(key, value);
        }
        setFormValues((prev) => ({
            ...prev,
            [key]: value
        }));
    }

    const getStateData = async (field, countryid) => {
        let response = await getEmerlinkStatesAndCurrency(countryid);
        let stateData = response.stateData.record;
        if (!Array.isArray(stateData)) {
            stateData = [stateData];
        }
        let states = [];
        for (let state of stateData) {
            states.push({ 'value': state.stateProvinceCode, 'key': state.stateProvinceCode, 'label': state.stateProvinceName });
        }
        if (field === 'receivercountry') {
            setReceiverStates(states);
            return;
        }
        setReceivingStates(states);
        let currencyData = response.currencyData.record;
        if (!Array.isArray(currencyData)) {
            currencyData = [currencyData];
        }
        let currencies = [];
        for (let currency of currencyData) {
            currencies.push({ 'value': currency, 'key': currency, 'label': currency });
        }
        setReceivingCurrencies(currencies);
    }

    const checkContactExists = () => {
        for (let contact of contacts) {
            let contactData = contact.Usercontactlistexternal
            if (contactData.firstName === formValues.receiverfirstname && contactData.lastName === formValues.receiverlastname) {
                setFormValues((prev) => ({
                    ...prev,
                    contactExists: true
                }));
                setContactButtonText("Contact Already Saved");
                setDisableContactButton(true);
                break;
            }
        }
    }

    const saveContact = async () => {
        let contactData = {
            relationshipreceiver: formValues.relationship ? formValues.relationship : formValues.relationshipreceiver,
            receivecountry: formValues.receivecountry,
            currencytoreceive: formValues.currencytoreceive,
            receivingcountry: formValues.receivingcountry ? formValues.receivingcountry : formValues.receivercountry,
            receiverstate: formValues.receiverstate,
            userid: selectedUserID,
            contactfirstname: formValues?.receiverfirstname,
            contactlastname: formValues?.receiverlastname
        }
        let response = await addEmerlinkContact(contactData);
        setDisableContactButton(true);
        if (response.Status !== '1') {
            setAlertData(response, true, false);
            setContactButtonText("Could not save contact");
            return;
        }
        setContactButtonText("Contact Saved");
    }

    const getContactInformation = () => {
        if (!selectedContact) return;
        const data = selectedContact.Usercontactlistexternal;
        let otherdata = {};
        try {
            otherdata = JSON.parse(data.other.replaceAll(/&(amp;)*quot;/g, '"'));
        } catch (error) {

        }
        return (
            <Box>
                <Box>Name: {data.firstName} {data.lastName}</Box>
                <Box>Country: {otherdata.ctry}</Box>
                {otherdata.state ? <Box>State: {otherdata.state}</Box> : ''}
            </Box>);
    }

    const handlePinConfirm = (event, pin) => {
        const userPin = pin.join('');
        if (formValues.transferType === 'send') {
            sendMoney(userPin);
        } else {
            receiveMoney(userPin);
        }
        setShowPin(false);
    };

    const validation = {
        send2: [
            "amount",
            "receivecountry",
            "receivestate",
            "currencytoreceive",
            "purposeoftrn",
            "relationshipreceiver"
        ],
        send3: [
            "receiverfirstname",
            "receiverlastname",
        ],
        getTransaction: [
            "receivercountry",
            "receiverstate",
        ],
        shortForm: [
            "amount",
            "purposeoftrn",
        ]
    }

    const validateForm = (page) => {
        const errors = {};
        const requiredFields = validation[page] || [];

        requiredFields.forEach((key) => {
            if (!formValues[key]) {
                errors[key] = true;
            }
        });

        setFormErrors(errors);
        if (Object.keys(errors).length !== 0) {
            return;
        }
        if (page === "shortForm") {
            page = "getTransaction";
        }
        setPage(page);
        return Object.keys(errors).length === 0; // Return true if no errors
    };

    const handleAlertClick = (prev) => {
        setAlert({ ...prev, showAlert: false });
        handleBack();
    }

    const setAlertData = (response, isError, goToLanding) => {
        if (isError) {
            const errorMessage = getErrorMessage(response);
            setAlert({
                showAlert: true,
                severity: "error",
                message: errorMessage,
                header: "Error"
            });
            if (goToLanding) {
                setPage('landing');
            }
        }
    }

    return (
        <Box className="container">
            <Box className="pageContainer">
                <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }} className="text-center">International Transfer - MoneyGram</Typography>
                {page === 'landing' ?

                    <Box>
                        <Box className="contactContainer">
                            <Box className="d-flex justify-content-between">
                                <Box className="lh-lg fw-bold">Contacts</Box>
                            </Box>
                            <Contacts
                                service={"EMER"}
                                contacts={contacts}
                                setSelectedContact={setSelectedContact}
                                displaySendAgain={isDevEnv ? true : false}
                            />
                        </Box>
                        <Box className="historyContainer mt-3">
                            <Box className="fw-bold">Recent History</Box>
                            <InternationalTransferHistory
                                history={history}
                                service="EMERLINK"
                                displayAmount={4}
                                trackTransaction={trackTransaction}
                                handleResend={resendTransaction}
                            />
                        </Box>
                        <InternationalTransferFooterButtons
                            handleButtonOne={handleBack}
                            handleButtonTwo={() => setPage('receive')}
                            handleMiddleButton={() => setPage('send')}
                            buttonOneText="Return"
                            buttonTwoText="Receive Money"
                            middleButtonText="Send Money To New Contact"
                            showMiddleButton={isDevEnv ? true : false}
                        />
                    </Box> : ''}
                {page === 'send' ?
                    <Box
                        sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}>
                        <RegistrationInput
                            label="Amount"
                            type="number"
                            onChange={(e) => editFormValues('amount', e.target.value)}
                            value={formValues.amount}
                            hasError={formErrors.amount} />
                        <RegistrationSelect
                            label="Receiving Country"
                            options={countryList}
                            required={true}
                            onChange={(e) => editFormValues('receivecountry', e.target.value)}
                            value={formValues.receivecountry}
                            hasError={formErrors.receivecountry} />
                        <RegistrationSelect
                            label="Receiving State"
                            options={receivingStates}
                            required={true}
                            onChange={(e) => editFormValues('receivestate', e.target.value)}
                            value={formValues.receivestate}
                            hasError={formErrors.receivestate} />
                        <RegistrationSelect
                            label="Currency"
                            options={receivingCurrencies}
                            required={true}
                            onChange={(e) => editFormValues('currencytoreceive', e.target.value)}
                            value={formValues.currencytoreceive}
                            hasError={formErrors.currencytoreceive} />
                        <RegistrationSelect
                            label="Purpose of Transaction"
                            options={purposesOptions}
                            required={true}
                            onChange={(e) => editFormValues('purposeoftrn', e.target.value)}
                            value={formValues.purposeoftrn}
                            hasError={formErrors.purposeoftrn} />
                        <RegistrationSelect
                            label="Relationship to Receiver"
                            options={relationshipOptions}
                            required={true}
                            onChange={(e) => editFormValues('relationshipreceiver', e.target.value)}
                            value={formValues.relationshipreceiver}
                            hasError={formErrors.relationshipreceiver} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={() => validateForm("send2")}
                            buttonOneText="Back"
                            buttonTwoText="Continue"
                        />
                    </Box>
                    : ''}
                {page === 'send2' ?
                    <Box
                        sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}>
                        <RegistrationInput
                            label="Receiver: First Name"
                            required={true}
                            onChange={(e) => editFormValues('receiverfirstname', e.target.value)}
                            value={formValues.receiverfirstname}
                            hasError={formErrors.receiverfirstname} />
                        {/* <RegistrationInput
                            label="Receiver: Middle Name"
                            required={false}
                            onChange={(e) => editFormValues('receivermiddlename', e.target.value)}
                            value={formValues.receivermiddlename}
                            hasError={formErrors.receivermiddlename} /> */}
                        <RegistrationInput
                            label="Receiver: Last Name"
                            required={true}
                            onChange={(e) => editFormValues('receiverlastname', e.target.value)}
                            value={formValues.receiverlastname}
                            hasError={formErrors.receiverlastname} />
                        <RegistrationInput
                            label="Receiver: Second Last Name"
                            required={false}
                            onChange={(e) => editFormValues('lastname2', e.target.value)}
                            value={formValues.lastname2}
                            hasError={formErrors.lastname2} />
                        <RegistrationInput
                            label="Receiver: Address"
                            required={false}
                            onChange={(e) => editFormValues('receiveraddress', e.target.value)}
                            value={formValues.receiveraddress}
                            hasError={formErrors.receiveraddress} />
                        <RegistrationInput
                            label="Receiver: City"
                            required={false}
                            onChange={(e) => editFormValues('receivercity', e.target.value)}
                            value={formValues.receivercity}
                            hasError={formErrors.receivercity} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('send')}
                            handleButtonTwo={() => validateForm("send3")}
                            buttonOneText="Back"
                            buttonTwoText="Continue"
                        />
                    </Box>
                    : ''}
                {page === 'send3' ?
                    <Box
                        sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}>
                        <RegistrationInput
                            label="Receiver: Postal / Zip Code"
                            required={false}
                            onChange={(e) => editFormValues('receiverpostal', e.target.value)}
                            value={formValues.receiverpostal}
                            hasError={formErrors.receiverpostal} />
                        <RegistrationSelect
                            label="Receiver's Citizenship Country"
                            required={true}
                            options={countryList}
                            onChange={(e) => editFormValues('receivercountry', e.target.value)}
                            value={formValues.receivercountry}
                            hasError={formErrors.receivercountry} />
                        <RegistrationSelect
                            label="Receiver's State of Citizenship"
                            required={true}
                            options={receiverStates}
                            onChange={(e) => editFormValues('receiverstate', e.target.value)}
                            value={formValues.receiverstate}
                            hasError={formErrors.receiverstate} />
                        <RegistrationInput
                            label="Receiver: Phone Number"
                            required={false}
                            onChange={(e) => editFormValues('receiverphoneno', e.target.value)}
                            value={formValues.receiverphoneno}
                            hasError={formErrors.receiverphoneno} />
                        <RegistrationInput
                            label="Message to Recipient"
                            required={false}
                            onChange={(e) => editFormValues('receivermessage', e.target.value)}
                            value={formValues.receivermessage}
                            hasError={formErrors.receivermessage} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('send2')}
                            handleButtonTwo={() => validateForm("getTransaction")}
                            buttonOneText="Back"
                            buttonTwoText="Continue"
                        />
                    </Box>
                    : ''}
                {page === 'receive' ?
                    <Box
                        sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}>
                        <RegistrationInput
                            label="Reference Number"
                            type="text"
                            onChange={(e) => editFormValues('referencenumber', e.target.value)}
                            value={formValues.referencenumber} />
                        <RegistrationSelect
                            label="Purpose of Funds"
                            options={fundPurposesOptions}
                            required={true}
                            onChange={(e) => editFormValues('fundpurpose', e.target.value)}
                            value={formValues.fundpurpose} />
                        {formValues.fundpurpose === 'OTHER' &&
                            <RegistrationSelect
                                label="Purpose of Funds: Other"
                                options={fundPurposesOptions}
                                required={true}
                                onChange={(e) => editFormValues('fundpurposeother', e.target.value)}
                                value={formValues.fundpurposeother} />
                        }
                        <RegistrationSelect
                            label="Purpose of Transaction"
                            options={purposesOptions}
                            required={true}
                            onChange={(e) => editFormValues('purposeoftrn', e.target.value)}
                            value={formValues.purposeoftrn} />
                        <RegistrationSelect
                            label="Relationship to Sender"
                            options={relationshipOptions}
                            required={true}
                            onChange={(e) => editFormValues('relationshipsender', e.target.value)}
                            value={formValues.relationshipsender} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={() => setPage("getTransaction")}
                            buttonOneText="Back"
                            buttonTwoText="Continue"
                        />
                    </Box> : ''}
                {page === 'summary' ?
                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}>
                        <Box className={'d-flex mt-2 justify-content-between'}>
                            <Box>First Name:</Box>
                            <Box>{formValues.receiverfirstname}</Box>
                        </Box>
                        {formValues.receivermiddlename && <Box className={'d-flex mt-2 justify-content-between'}>
                            <Box>Middle Name:</Box>
                            <Box>{formValues.receivermiddlename}</Box>
                        </Box>}
                        <Box className={'d-flex mt-2 justify-content-between'}>
                            <Box>Last Name:</Box>
                            <Box>{formValues.receiverlastname}</Box>
                        </Box>
                        {formValues.lastname2 && <Box className={'d-flex mt-2 justify-content-between'}>
                            <Box>Second Last Name:</Box>
                            <Box>{formValues.lastname2}</Box>
                        </Box>}
                        <Box className={'d-flex mt-2 justify-content-between'}>
                            <Box>Country:</Box>
                            <Box>{formValues.receivecountry}</Box>
                        </Box>
                        <Box className={'d-flex mt-2 justify-content-between'}>
                            <Box>Transfer Amount:</Box>
                            <Box>${parseFloat(formValues.amount).toFixed(2)}</Box>
                        </Box>
                        {formValues?.servicefee &&
                            <Box className={'d-flex mt-2 justify-content-between'}>
                                <Box>Transfer Fee:</Box>
                                <Box>${parseFloat(formValues.servicefee).toFixed(2)}</Box>
                            </Box>
                        }
                        {formValues.taxamount &&
                            <Box className={'d-flex mt-2 justify-content-between'}>
                                <Box>DFSST:</Box>
                                <Box>${parseFloat(formValues.taxamount).toFixed(2)}</Box>
                            </Box>}
                        
                        {formValues.taxamount &&
                            <Box className={'d-flex mt-2 justify-content-between'}>
                                <Box>Sub Total Amount:</Box>
                                <Box>${(parseFloat(formValues.amount) + parseFloat(formValues.servicefee) + parseFloat(formValues.taxamount)).toFixed(2)}</Box>
                            </Box>}

                        {formValues.adminfee &&
                            <Box className={'d-flex mt-2 justify-content-between'}>
                                <Box>Digital Account Fee:</Box>
                                <Box>${parseFloat(formValues.adminfee).toFixed(2)}</Box>
                            </Box>}
                        <Box className={'d-flex mt-2 justify-content-between'}>
                            <Box>Withdrawal Amount:</Box>
                            <Box>${parseFloat(formValues.totalamount).toFixed(2)}</Box>
                        </Box>
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={() => setPage("sendTransaction")}
                            buttonOneText="Cancel"
                            buttonTwoText={formValues.transferType === 'send' ? 'Confirm and Send' : 'Receive Money'}
                            middleButtonText={contactButtonText}
                            handleMiddleButton={saveContact}
                            showMiddleButton={true}
                            disableMiddleButton={disableContactButton}
                        />
                    </Box>
                    : ''}

                {page === 'summaryreceive' ?
                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}>
                        <Box className={'d-flex mt-2 justify-content-between'}>
                            <Box>From Sender</Box>
                            <Box>{decodeHtmlEntities(formValues.senderFirstName)} {decodeHtmlEntities(formValues.senderLastName)}</Box>
                        </Box>
                        <Box className={'d-flex mt-2 justify-content-between'}>
                            <Box>From Country:</Box>
                            <Box>{formValues.originatingCountry}</Box>
                        </Box>
                        <Box className={'d-flex mt-2 justify-content-between'}>
                            <Box>Send Date</Box>
                            <Box>{formValues.dateTimeSent}</Box>
                        </Box>
                        <Box className={'d-flex mt-2 justify-content-between'}>
                            <Box>Total Amount to Receive:</Box>
                            <Box>${parseFloat(formValues.totalamount).toFixed(2)}</Box>
                        </Box>
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={() => setShowPin(true)}
                            buttonOneText="Cancel"
                            buttonTwoText={'Receive Money'}
                            showMiddleButton={false}
                        />
                    </Box>
                    : ''}


                {page === 'shortform' ?

                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}>
                        <RegistrationInput
                            label="Amount"
                            type="number"
                            onChange={(e) => editFormValues('amount', e.target.value)}
                            value={formValues.amount}
                            hasError={formErrors.amount} />
                        <RegistrationSelect
                            label="Purpose of Transaction"
                            options={purposesOptions}
                            required={true}
                            onChange={(e) => editFormValues('purposeoftrn', e.target.value)}
                            value={formValues.purposeoftrn}
                            hasError={formErrors.purposeoftrn} />
                        <InternationalTransferFooterButtons
                            handleButtonOne={() => setPage('landing')}
                            handleButtonTwo={() => validateForm("shortForm")}
                            buttonOneText="Back"
                            buttonTwoText="Continue"
                        />
                    </Box>
                    : ''
                }
                {page === 'receipt' ?
                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}>
                        <Box>
                            <Typography
                                sx={{
                                    fontFamily: "'Nunito'",
                                    fontStyle: "normal",
                                    fontWeight: 500,
                                    fontSize: "21.4825px",
                                    color: "#3A3A3A",
                                }}
                                className="text-center">
                                Transaction Complete
                            </Typography>
                            <Box className={'d-flex mt-2 justify-content-between'}>
                                <Box>Reference Number:</Box>
                                <Box>{formValues.emerlinkrefnumber}</Box>
                            </Box >
                            <Box className={'d-flex mt-2 justify-content-between'}>
                                <Box>Transaction ID:</Box>
                                <Box>{formValues.refid}</Box>
                            </Box>
                        </Box>
                        <Box>
                            <Typography
                                sx={{
                                    fontFamily: "'Nunito'",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    fontSize: "18px",
                                    color: "#3A3A3A",
                                }}
                                className="mt-2" >Sender Details</Typography>
                            <Box>
                                <Box className={'d-flex mt-2 justify-content-between'}>
                                    <Box>Sender Name:</Box>
                                    <Box>{formValues.transferType === 'send' ? decodeHtmlEntities(selectedUser.User.firstName) : decodeHtmlEntities(formValues.senderFirstName)} {formValues.transferType === 'send' ? decodeHtmlEntities(selectedUser.User.lastName) : decodeHtmlEntities(formValues.senderLastName)}</Box>
                                </Box>
                                {formValues.transferType === 'send' &&
                                    <Box className={'d-flex mt-2 justify-content-between'}>
                                        <Box>Transfer Amount:</Box>
                                        <Box>{parseFloat(formValues.amount).toFixed(2)}</Box>
                                    </Box>
                                }
                                {formValues.servicefee !== 0 &&
                                    <Box className={'d-flex mt-2 justify-content-between'}>
                                        <Box>Transfer Fee:</Box>
                                        <Box>{parseFloat(formValues.servicefee).toFixed(2)}</Box>
                                    </Box>}
                                {formValues.taxamount !== 0 &&
                                    <Box className={'d-flex mt-2 justify-content-between'}>
                                        <Box>DFSST:</Box>
                                        <Box>{parseFloat(formValues.taxamount).toFixed(2)}</Box>
                                    </Box>
                                }
                                {formValues.taxamount !== 0 &&
                                    <Box className={'d-flex mt-2 justify-content-between'}>
                                        <Box>Digital Account Fee:</Box>
                                        <Box>{parseFloat(formValues.adminfee).toFixed(2)}</Box>
                                    </Box>
                                }
                                {formValues.transferType === 'send' &&
                                    <Box className={'d-flex mt-2 justify-content-between'}>
                                        <Box>Total Amount Withdrawn:</Box>
                                        <Box>{parseFloat(formValues.totalamount).toFixed(2)}</Box>
                                    </Box>
                                }
                            </Box>
                            <Typography
                                sx={{
                                    fontFamily: "'Nunito'",
                                    fontStyle: "normal",
                                    fontWeight: 600,
                                    fontSize: "18px",
                                    color: "#3A3A3A",
                                }}
                                className="mt-2" >Recipient Details</Typography>
                            <Box>
                                <Box className={'d-flex mt-2 justify-content-between'}>
                                    <Box>First Name:</Box>
                                    <Box>{formValues.transferType === 'send' ? decodeHtmlEntities(formValues.receiverfirstname) : decodeHtmlEntities(selectedUser.User.firstName)} </Box>
                                </Box>
                                <Box className={'d-flex mt-2 justify-content-between'}>
                                    <Box>Last Name:</Box>
                                    <Box>{formValues.transferType === 'send' ? decodeHtmlEntities(formValues.receiverlastname) : decodeHtmlEntities(selectedUser.User.lastName)}</Box>
                                </Box>
                                {formValues.lastname2 && <Box className={'d-flex mt-2 justify-content-between'}>
                                    <Box>Second Last Name:</Box>
                                    <Box>{formValues.lastname2}</Box>
                                </Box>}
                            </Box>
                            {formValues.transferType !== 'send' &&
                                    <Box className={'d-flex mt-2 justify-content-between'}>
                                        <Box>Total Amount Deposited:</Box>
                                        <Box>{parseFloat(formValues.totalamount).toFixed(2)}</Box>
                                    </Box>
                                }
                            <Box className="buttonContainer mt-4">
                                <Button
                                    variant="contained"
                                    className="me-2"
                                    color="primary" onClick={() => {
                                        setFormValues({});
                                        setPage("landing")
                                    }}>Return</Button>
                            </Box>
                        </Box>
                    </Box>
                    : ''}
            
                {page === 'contact' ?
                    <Box sx={{
                        maxHeight: "600px",
                        marginTop: "10px"
                    }}>
                        {getContactInformation()}
                        <Box className="buttonContainer">
                            <Button
                                variant="contained"
                                className="me-2"
                                color="primary" onClick={() => setPage("landing")}>Cancel</Button>
                            <Button
                                variant="contained"
                                color="primary" onClick={() => sendToContact()}>Send To This Contact</Button>
                        </Box>
                    </Box>
                    : ''
                }
                {
                    page === 'wait' ?
                        <Box sx={{
                            maxHeight: "600px",
                            marginTop: "10px"
                        }}>
                            <Box
                                className="mt-5 d-flex justify-content-center align-items-center">
                                <CircularProgress
                                    size="10rem" />
                            </Box>
                        </Box>
                        : ''
                }

                {
                    page === 'track' &&
                    <InternationalTransferTrack
                        transactionStatus={transactionStatus}
                        handleReturn={() => setPage('landing')}
                    />
                }
                <PinPad 
                    show={showPin} 
                    handleConfirm={handlePinConfirm}
                />
                <CustomAlert 
                    severity={alert.severity} 
                    show={alert.showAlert} 
                    header={alert.header} 
                    message={alert.message} 
                    onClick={() => handleAlertClick()} 
                    autoclose={alert.severity === "error" ? false : true} 
                />
            </Box>
        </Box>
    );
}

export default Emerlink;